import { Pipe, PipeTransform } from "@angular/core";
import { ConversionUtils } from "../domain/conversion-utils";

const DEFAULT = "00:00:00.000";

@Pipe({
  name: "timecode",
})
export class TimecodePipe implements PipeTransform {
  transform(
    time: number,
    frameRate: number,
    timecodeFormat: string,
    hideZeros: boolean = false,
  ): string {
    if (typeof time !== "number") {
      return DEFAULT;
    }
    if (time <= 0 || isNaN(time)) {
      return DEFAULT;
    }

    const timespan = ConversionUtils.convertMiliseconds(time);
    let totalFps = 0;
    console.log(
      "ReplaceShowModalItemIsLongerComponent->TimecodePipe",
      timecodeFormat,
      frameRate,
    );
    if (
      timecodeFormat === "fps" &&
      typeof frameRate === "number" &&
      frameRate > 0
    ) {
      totalFps = ConversionUtils.getFpsFromMs(timespan.ms, frameRate);
    }

    const end =
      timecodeFormat === "fps"
        ? `:${this.fixNumber(totalFps)}`
        : `.${this.fixMS(timespan.ms)}`;
    return `${this.fixNumber(timespan.h)}:${this.fixNumber(timespan.m)}:${this.fixNumber(timespan.s)}${end}`;
  }

  fixNumber(number) {
    number = parseInt(number, 10);
    return number < 10 ? "0" + number : number;
  }

  fixMS(number) {
    number = parseInt(number, 10);
    return number < 10 ? "00" + number : number < 100 ? "0" + number : number;
  }
}
